import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";

export default function NotFound() {
  return (
    <PublicLayout>
      <Seo title="Page Not Found" noindex />
      <section className="min-h-[60vh] grid place-items-center px-4 pt-24">
        <div className="text-center">
          <div className="font-display text-7xl font-extrabold text-gradient">404</div>
          <h1 className="font-display text-2xl font-bold mt-4">Page Not Found</h1>
          <p className="text-slate-400 mt-2">The page you're looking for doesn't exist or has moved.</p>
          <div className="mt-6 flex gap-3 justify-center">
            <Link to="/"><Button className="bg-brand-emerald text-white">Go Home</Button></Link>
            <Link to="/jobs"><Button variant="outline" className="border-white/15">Browse Jobs</Button></Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
